import React, { Component } from 'react';
import './AdminEditCoupons.css';
import iconpen from '../../../../image/iconpen.svg'
import iconCalendar from '../../../../image/iconCalendar.svg'
import closeicon from '../../../../image/closeicon.svg'
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";


class AdminEditCoupons extends Component {
  
    render() {
        return (
            <div className="EditFAQ">
                
               
                <p className="col-md-6 mt-2 p-0 fontsize4 font-weight-bold ">Coupon details</p>
                <hr />
                <div className="col-md-8 d-sm-flex justify-content-sm-between">
                    <p className="fontsize12 text-muted ">Coupon created May 12, 2019</p>
                    <p className="fontsize12 text-muted ">Coupon used: 689 times</p>
                </div>
                <div className="form-group">
                        <label className="form-check-label fontsize11 col-sm-4 col-md-6 col-lg-3" >Name</label>
                        <input type="text" className="form-control d-inline col-lg-3 col-md-6 col-sm-6 badge-pill" placeholder="Name"name="name" value={this.props.state.name} disabled/>
                        <div style={{ fontSize: 12, color: "red" }}>
                                        {this.props.state.nameError}
                                    </div>
                </div>
                <div className="form-group">
                        <label className="form-check-label fontsize11 col-sm-4 col-md-6 col-lg-3" >Amount</label>
                        <input type="number" className="form-control d-inline col-lg-3 col-md-6 col-sm-6 badge-pill" placeholder="Amount EGP"name="amount"  value={this.props.state.amount} onChange={this.props.handleChange}/>
                        <div style={{ fontSize: 12, color: "red" }}>
                                        {this.props.state.amountError}
                        </div>
                </div>
                <div className="form-group">
                        <label className="form-check-label fontsize11 col-sm-4 col-md-6 col-lg-3" >Min order amount</label>
                        <input type="number" className="form-control d-inline col-lg-3 col-md-6 col-sm-6 badge-pill" placeholder="Min order amount"name="minorderamount" value={this.props.state.minorderamount}  onChange={this.props.handleChange}/>
                        <div style={{ fontSize: 12, color: "red" }}>
                                        {this.props.state.minorderamountError}
                        </div>
                </div>
               <div className="form-check mx-3 my-2 ">
                    <input className="form-check-input" type="radio" name="gridRadios" id="gridRadios1"   checked={this.props.state.onlyfirstorder ? 'checked' : ''} onClick={this.props.onlyfirstorder} />
                    <label className="form-check-label fontsize11 col-sm-4 col-md-6 col-lg-3" htmlFor="gridRadios1">
                    Only use with FIRST order
                    </label>

                </div>
                <div className="form-check mx-3 my-2">
                    <input className="form-check-input" type="radio" name="gridRadios" id="gridRadios2" checked={!this.props.state.onlyfirstorder ? 'checked' : ''}  onClick={this.props.limitedtimes}/>
                    <label className="form-check-label fontsize11 col-sm-4 col-md-6 col-lg-3" htmlFor="gridRadios2">
                    Limited times usage
                    </label>
                    <input type="text" className="form-control d-inline col-lg-3 col-md-6 col-sm-6  badge-pill"  placeholder="Limited times usage" name="limitedtimes" value={this.props.state.limitedtimes}  onChange={this.props.handleChange} disabled={(!this.props.state.onlyfirstorder ? '' : 'disabled')}  />
                    <div style={{ fontSize: 12, color: "red" }}>
                                        {this.props.state.limitedtimesError}
                        </div>
                </div>
                <div style={{ fontSize: 12, color: "red" }}>
                                        {this.props.state.limitorfirstError}
                </div>
               
                <div className="form-group row p-3 mb-0">
                <p className="fontsize11 d-inline mt-2 mb-0">Valid from </p> 
                <img className="mr-5 ml-2 my-2" src={iconCalendar} alt="iconCalendar" />
                <DatePicker
                        className="badge-pill btn border"
                        dateFormat="MMMM d, yyyy h:mm aa"
                        selected={this.props.state.startDate}
                        onChange={date =>this.props.handleChangedate(date)}
                        minDate={new Date()}
                        showTimeSelect
                        placeholderText="Select a date"
                    /> 
                </div>
                <div className="form-group row p-3 mb-0">
                <p className="fontsize11 d-inline mt-2 mb-0">Valid untill</p> 
                <img className="mr-5 ml-2 my-2" src={iconCalendar} alt="iconCalendar" />
                <DatePicker
                        className="badge-pill btn border"
                        dateFormat="MMMM d, yyyy h:mm aa"
                        selected={this.props.state.EndDate}
                        onChange={date =>this.props.handleChangedate2(date)}
                        minDate={new Date()}
                        showTimeSelect
                        placeholderText="Select a date"
                    /> 
                </div>
                <div style={{ fontSize: 12, color: "red" }}>
                                        {this.props.state.dateError}
                </div>
                <div className="text-center d-flex justify-content-around  flex-wrap my-3 col-md-8">

                    <button onClick={this.props.EditCoupon} className="btn badge-pill p-2 pl-1 px-3  m-1 border shadow bg-white " ><img className="mr-1" src={iconpen} alt="" />SAVE EDIT </button>
                    <button onClick={this.props.handleDeleteCoupon} className="btn badge-pill p-2 pl-1 px-4  m-1 border shadow   bg-danger text-white" ><img className="mr-1 " src={closeicon} alt="" />CANCEL</button>
                    </div>
            </div>

        )
    }
}
export default AdminEditCoupons;